export const dash = '/dash/';
export const dashSeoPerformace = '/dash/seo-performance/';
